/**
 * node_modules
 */
import React, { useEffect, useState } from "react"
import { type GatsbyBrowser } from "gatsby"

/**
 * context
 */
import { EventsProvider, extractLocation } from "./src/context/events"

export const shouldUpdateScroll = ({ routerProps: { location }, getSavedScrollPosition }) => {
  window.history.scrollRestoration = "manual"
  const currentPosition = getSavedScrollPosition(location) || [0, 0]

  if (location.hash) {
    setTimeout(() => {
      const item = document.querySelector(location.hash)
      if (item) {
        item.scrollIntoView()
      }
    }, 50)
    return false
  }

  setTimeout(() => {
    window.scrollTo({
      top: currentPosition[1],
      left: currentPosition[0],
    })
  }, 50)

  return false
}

// Event 用のコンテキストをグローバルに設定する
export const wrapRootElement: GatsbyBrowser["wrapRootElement"] = ({ element, props }) => {
  // SSRフラグ
  const isSSR = typeof window === "undefined"

  // サーバーサイドではデフォルト値を使用
  return React.createElement(
    EventsProvider,
    {
      defaultValues: {
        filter: { location: isSSR ? null : extractLocation(window.location.pathname) },
      },
    },
    element,
  )
}
